/**
 * Centralized API client for the entire Genesis ecosystem.
 * Wraps axios with auth-aware credentials, base URL, and error normalization.
 */
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

const client = axios.create({
  baseURL: `${BASE}/api`,
  timeout: 60000,
  withCredentials: true,
});

// Normalize errors so callers receive { ok: false, status, message } instead of throwing
client.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const status = err?.response?.status || 0;
    const message = err?.response?.data?.detail || err?.message || "Network error";
    return Promise.reject({ ok: false, status, message, raw: err });
  }
);

const apiClient = {
  get: (path, params) => client.get(path, { params }).then((r) => r.data),
  post: (path, body) => client.post(path, body).then((r) => r.data),
  put: (path, body) => client.put(path, body).then((r) => r.data),
  patch: (path, body) => client.patch(path, body).then((r) => r.data),
  delete: (path) => client.delete(path).then((r) => r.data),
  raw: client,
};

export default apiClient;
